module.exports = __webpack_public_path__ + "static/media/not-available.b0ee76f8.svg";